export default __webpack_public_path__ + "static/media/user.61637315.png";